import { combineReducers } from 'redux';

import { reducer as experiments } from '@seek/experiments-js';
import { reducer as hotjarReducer } from 'redux-hotjar';

import dashboard from './dashboard/dashboard';
import featureFlags from './featureFlags/featureFlags';
import jobdetails from './jobdetails/jobdetails';
import joblistitem from './joblistitem/joblistitem';
import lastSearch from './lastSearch/lastSearch';
import lmis from './lmis/lmis';
import location from './location/location';
import nudges from './nudges/nudges';
import results from './results/results';
import savedJobs from './savedJobs/savedJobs';
import saveSearch from './saveSearch/saveSearch';
import search from './search/search';
import seo from './seo/seo';
import user from './user/user';
import fitme from './fitme/fitme';

export default combineReducers({
  dashboard,
  experiments,
  featureFlags,
  jobdetails,
  joblistitem,
  lastSearch,
  lmis,
  location,
  nudges,
  results,
  savedJobs,
  saveSearch,
  search,
  seo,
  user,
  fitme,
  ...hotjarReducer()
});
